import { render, staticRenderFns } from "./Challenge2.vue?vue&type=template&id=c76083f0&scoped=true&"
import script from "./Challenge2.vue?vue&type=script&lang=js&"
export * from "./Challenge2.vue?vue&type=script&lang=js&"
import style0 from "./Challenge2.vue?vue&type=style&index=0&id=c76083f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76083f0",
  null
  
)

export default component.exports